// Local: selektor zakresu dat z językiem kalendarza z i18n
// @ts-nocheck

import React, { FC, useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { parseISO, format } from 'date-fns';
import { pl, enUS } from 'date-fns/locale';
import { DateRange, DayPicker } from 'react-day-picker';
import Popover from '@mui/material/Popover';
import { Calendar } from 'react-bootstrap-icons';
import classnames from 'classnames';

import { useRWD } from 'hooks';

import styles from 'theme/components/controls/DateRangePicker/DateRangePicker.module.scss';
import 'react-day-picker/dist/style.css';

const localeMap: Record<string, typeof pl> = { pl, en: enUS };

interface IProps {
  dateRange?: {
    from?: string;
    to?: string;
  };
  onChange?: (dateRange: NonNullable<Required<IProps['dateRange']>>) => void;
}

const DateRangePicker: FC<IProps> = ({ dateRange, onChange }) => {
  const { i18n } = useTranslation();
  const locale = localeMap[i18n.language] ?? enUS;
  const { isMobile } = useRWD();

  const [isNewSelection, setIsNewSelection] = useState(true);
  const [range, setRange] = useState<DateRange>();
  const [popoverAnchor, setPopoverAnchor] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setDateRangeFromProps();
  }, [dateRange]);

  const setDateRangeFromProps = () => {
    const rangeFrom = dateRange?.from;
    const rangeTo = dateRange?.to;
    setRange({
      from: rangeFrom ? parseISO(rangeFrom) : undefined,
      to: rangeTo ? parseISO(rangeTo) : undefined
    });
  };

  const handleOnSelectDate = (range?: DateRange, selectedDate?: Date) => {
    if (isNewSelection || !range) {
      setRange({ from: selectedDate });
      setIsNewSelection(false);
    } else {
      setRange(range);
      setIsNewSelection(true);
      setPopoverAnchor(null);
      range.from &&
        range.to &&
        onChange?.({
          from: format(range.from, 'yyyy-MM-dd'),
          to: format(range.to, 'yyyy-MM-dd')
        });
    }
  };

  const handleOnClosePopover = () => {
    setPopoverAnchor(null);
    setDateRangeFromProps();
  };

  return (
    <>
      <button
        onClick={({ currentTarget }) => setPopoverAnchor(currentTarget)}
        className={classnames(styles.button, 'StylePath-Components-Controls-DateRangePicker')}>
        {range?.from && range?.to ? (
          <span>
            {format(range.from, 'dd.MM.yyyy')}
            {range.to && ` - ${format(range.to, 'dd.MM.yyyy')}`}
          </span>
        ) : (
          <span className={styles.placeholder}>
            <Trans>Wybierz zakres dat</Trans>
          </span>
        )}
        <Calendar />
      </button>
      <Popover
        anchorEl={popoverAnchor}
        open={!!popoverAnchor}
        onClose={handleOnClosePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}>
        <DayPicker
          locale={locale}
          mode="range"
          numberOfMonths={isMobile ? 1 : 2}
          selected={range}
          onSelect={handleOnSelectDate}
        />
      </Popover>
    </>
  );
};

export default DateRangePicker;
